import Alpine from 'alpinejs'
import axios from 'axios'
import accessibility from './components/alpine-accessibility'
import navigation from './components/alpine-navigation'
import breakpoint from './components/alpine-breakpoint'
import cssVariable from './components/alpine-css-variable'
import collapse from '@alpinejs/collapse'
import focus from '@alpinejs/focus'
import modal from './components/alpine-modal'
import persist from '@alpinejs/persist'
import './components/alpine-persist-cookie-storage'
import { naturalSticky } from './components/NaturalSticky'

Alpine.plugin(accessibility)
Alpine.plugin(breakpoint)
Alpine.plugin(cssVariable)
Alpine.plugin(collapse)
Alpine.plugin(focus)
Alpine.plugin(modal)
Alpine.plugin(navigation)
Alpine.plugin(persist)
Alpine.start()

window.Alpine = Alpine
window.axios = axios

naturalSticky(document.querySelector('#header-main'))

const setChatbotNationAsAriaHidden = function (event) {
    const insertedNode = event.target;
    if (insertedNode.id === 'botnation-chatbox-container') {
        insertedNode.ariaHidden = 'true';
        document.body.removeEventListener('DOMNodeInserted',  setChatbotNationAsAriaHidden)
    }
}
document.body.addEventListener('DOMNodeInserted',  setChatbotNationAsAriaHidden)

const addClassAfterCookiesPreferencesSet = function (event) {
    if ((typeof event.target.classList !== 'undefined' && event.target.classList.contains('orejime-Button')) || document.cookie.search("sc_orejime") !== -1) {
        document.querySelector('#orejime').classList.add('orejime-set')
    }
}
document.body.addEventListener('click',  addClassAfterCookiesPreferencesSet)
addEventListener('DOMContentLoaded',  addClassAfterCookiesPreferencesSet)

